<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;margin-left: 25px;margin-right: 0px;">
        <div class="table-list">
            <div class="table-list-title">
                <span class="myTitle">IP授权申请</span>
                <div class="choose-group">
                    <span class="choose-group-span">订单状态</span>
                    <i-select v-model="statusIP"  placeholder="全部" style="width:126px">
                        <i-option v-for="(item,index) in statusList" :key="index" :value="item.value">{{ item.name }}</i-option>
                    </i-select>
                    <button class="btn-84 addBtn" style="margin-left:15px" @click="getByPage">查询</button>
                </div>
            </div>
            <Row class="table-style-size">
                <i-col span="7">申请IP</i-col>
                <i-col span="4">申请编号</i-col>
                <i-col span="6">相关文件</i-col>
                <i-col span="6">订单状态</i-col>
                <i-col span="6">创建时间</i-col>

                <i-col span="5">操作</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" style="height:90px" v-for="(item,index) in records" :key="index">
                    <i-col span="7" class="evdience-table">
                       <div class="ipshenqing">
                           <img :src="item.img" alt='版权登记'/>
                           <div class="info">
                               <div class="title">{{item.title}}</div>
                               <div class="money">￥{{item.estimated_amount}}起</div>
                           </div>
                       </div>
                    </i-col>
                    <i-col span="4">{{item.order_num}}</i-col>
                    <i-col span="6">
                        <div style="color:#2196F3;cursor: pointer;" @click="IPLicenseFile(item.uuid)">相关文件</div>
                    </i-col>
                    <i-col span="6">
                        {{item.status == 0?"申请中":item.status == 2?"已完成":"已取消"}}
                    </i-col>
                    <i-col span="6">{{item.created_at}}</i-col>
                    <i-col span="5">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <button class="btn-84 addBtn" style="margin-right: 0;" @click="IPLicenseDetails(item.uuid,item.ip_uuid,item.apply_type)">订单详情</button>
                            <button v-if="item.status == 0" class="btn-84 addBtn" @click="onCexiao(item.uuid)">撤销申请</button>
                        </div>
                    </i-col>
                </Row>
            </div>
            <div class="empty-box" v-if="records.length<=0">
                <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>
        </div>

        <!-- <generalframe myheight="450" mywidth="800" @fatherMethod="showDialog = false" v-if="showDialog"
                      maintitle="确认申请电子数据保管函" ref="mychild">
            <div style="margin-top: 30px;font-size: 15px;">电子数据保管函是由厦门市公证处出具的确认函文件</div>
            <div style="display: flex; margin-top: 30px; min-height: 200px">
                <div style="width: 150px; line-height: 42px;">支付方式：</div>
                <div>
                    <component :is="PayWayCom" @onselected="payWay = $event" type="13" encType='0301' :orderNo="applyNotarizationNum"></component>
                </div>
            </div>
            <input @click="applyNotarizationSubmit()" :disabled="disabled" class="submit-button" type="button"
                   value="确定"/>
        </generalframe> -->
        <generalframe myheight="450" mywidth="500" @fatherMethod="showDialog = false" v-if="showDialog"
                      maintitle="确认申请电子数据保管函" ref="mychild">
            <!-- <div style="margin-top: 30px;font-size: 15px;">电子数据保管函是由厦门市公证处出具的确认函文件</div> -->
            <div style="display: flex; margin-top: 30px; min-height: 200px">
                <component :is="PayWayCom" @onselected="payWay = $event" type="13" encType='0301' :orderNo="applyNotarizationNum" @resFn="resFn"></component>
            </div>
            <input disabled class="submit-button" type="button" style='background: #cfcfcf;cursor: no-drop;' value="确定" v-if='dzRes && ((Number(dzRes.amout)<Number(dzRes.price)) || (dzRes.packageNum == 0 && dzRes.price ==0))'/>
            <input @click="applyNotarizationSubmit()" :disabled="disabled" class="submit-button" type="button" v-else
                   value="确定"/>
            <!-- <div style="width: 230px;margin:10px auto 0;display: flex;justify-content: space-between;">
                <span>余额：{{dzRes && dzRes.amountDesc}}</span>
                <a style="cursor: pointer;" @click='goCz' v-if='dzRes && (Number(dzRes.amout)<Number(dzRes.price))'>去充值</a>
            </div> -->
        </generalframe>
        <logindDalog ref="logindDalog" :dataObj="dataObj" @confirm="confirm"></logindDalog>
    </div>

</template>

<script>
    import {userOrderList,cancelOrder,gettokenLogin} from "@/api/ipAuth.js";

    import {_downloadEnc, _generateEncByEvidencePage} from '@/api/notarization';
    import Cookies from "js-cookie";
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe.vue'
    import payWay from '@/views/main-components/pay-way-enc';

    import logindDalog from "@/viewsGangAn/components/logindDalog"

    export default {
      metaInfo: {
        title: 'IP授权申请|前海版权综合服务平台',
        meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        }, {
          name: 'Description',
          content: '会员信息,前海版权服务平台,人人都是创作者，人人都是版权人。前海版权服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        }]
      },
        name: 'myEvidence',
        components: {
            generalframe,
            payWay,
            logindDalog
        },
        data() {
            return {
                total: 0,
                pages: 0,
                pageNumber: 1,
                pageSize: 6,
                records: [],
                dateVal: [],
                beginTime: "",
                endTime: "",
                nameVal: "",
                currentIndex: null,
                titleVal: "",
                flag: false,
                flagType: 1,
                ifNotarizationSuccess: require('@/assets/notarization_active.png'),
                ifNotarizationFail: require('@/assets/notarization.png'),
                showDialog: false,
                payWay: null,
                disabled: false,
                PayWayCom: 'payWay',
                applyNotarizationNum: '',
                dzRes:null,
                dataObj: {
                    title:'撤销申请',
                    content:'是否确认撤销',
                    dalogType: 0
                },
                // ip
                statusList: [
                    {
                        name: '全部',
                        value: '-1'
                    },
                    {
                        name: '申请中',
                        value: '0'
                    },
                    {
                        name: '已完成',
                        value: '2'
                    },
                    {
                        name: '已取消',
                        value: '3'
                    },
                ],
                statusIP: '-1',
                deluuid: ''
            }
        },
        methods: {
            onCexiao(uuid) {
                this.deluuid = uuid
                this.$refs.logindDalog.closeDialog()
            },
             //取消ip授权
            confirm(e){
                let accessUuid = Cookies.get("userInfoIP") == undefined || Cookies.get("userInfoIP") == 'undefined' || Cookies.get("userInfoIP") == null || Cookies.get("userInfoIP") == ''?'':JSON.parse(Cookies.get("userInfoIP")).uuid

                let data = {
                    platform: "PC",
                    action_id: this.deluuid,
                    uuid: this.deluuid,
                    user_id: accessUuid
                }

                cancelOrder(data).then(res => {
                    if (res.code == 200) {
                        this.$refs.logindDalog.closeDialog()
                        this.getByPage()
                    }
                });
            },
            IPLicenseDetails(id, uuid, type){
                const newHref = this.$router.resolve({name: `/IPLicenseDetails?id=${id}&ip_uuid=${uuid}&type=${type}`})
                window.open(newHref.location.name,'_blank')
            },
            resFn(data){
                this.dzRes = data;
            },
            getByPage() {
                let accessUuid = Cookies.get("userInfoIP") == undefined || Cookies.get("userInfoIP") == 'undefined' || Cookies.get("userInfoIP") == null || Cookies.get("userInfoIP") == ''?'':JSON.parse(Cookies.get("userInfoIP")).uuid
                const data = {
                    page: 1,
                    page_size: 100,
                    platform: "PC",
                    status: this.statusIP,
                    user_id: accessUuid
                }
                userOrderList(data).then(res => {
                    if (res.code == 200) {
                        this.records = res.data;
                    }
                });
            },


            //分页
            changepage(index) {
                this.pageNumber = index
                this.getByPage()
            },
            //日期
            changeDate(val) {
                this.dateVal = val;
                this.pageNumber = 1;
                this.getByPage()
            },
            //搜索名称
            changeName() {
                console.log(this.nameVal)
                this.pageNumber = 1;
                this.getByPage()
            },
            //编辑标题
            editeRemark(index, name) {
                console.log(index)
                this.currentIndex = index;
                this.titleVal = name
            },
            changeTitle(id, orderSeqNo) {

            },
            //详情
            pushInfo(item) {
                this.$router.push({name: 'evidenceInfo', query: {id: item}})
            },
            IPLicenseFile(uuid) {
                const newHref = this.$router.resolve({name: `/IPLicenseFile?uuid=${uuid}`})
                window.open(newHref.location.name,'_blank')
            },
            //重新截取
            againSubmit(val) {

            },
            //证据包
            downUrl(item) {
                if (item.packageUrl) {
                    const links = item.packageUrl;
                    let aDom = document.createElement("a");
                    aDom.target = "_self";
                    aDom.href = links;
                    aDom.download = links.substr(links.lastIndexOf('/'), links.length);
                    aDom.click();
                }
            },
            //下载Bc
            downBcBook(id) {
                window.open(this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?evidenceOrderSeqNos=" + id, '_self');
            },
            //证书核验
            openVerify(val) {
                let routeUrl = this.$router.resolve({
                    path: "/index/creation_verification",
                    name: 'creationVerification',
                    params: {type: this.flagType, id: val}
                });
                window.open(routeUrl.href, '_blank');
            },
            newOpen() {
                window.open('/gananWebForensicsUp', '_blank');
            },

            /**************************电子数据确认函-打开加油包*************************/
            applyNotarization(data) {
                let _this = this
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                if (!userInfo || userInfo == '') {
                    _this.$store.state.app.showLoginOrRegistter = true;
                    return false;
                }
                _this.applyNotarizationNum = data;
                _this.showDialog = true;
                _this.PayWayCom = 'payWay'

            },

            /**************************电子数据确认函-提交*************************/
            applyNotarizationSubmit() {
                this.disabled = true;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                const data = {orderSeqNo: this.applyNotarizationNum};
                // if (!this.payWay) {
                //     toast('无可用次数');
                //     this.disabled = false;
                //     return false;
                // } else {
                //     if (this.payWay.gift.activityGiftId) {
                //         Object.assign(data, {activityGiftId: this.payWay.gift.activityGiftId})
                //     }
                // }

                _generateEncByEvidencePage(data).then(res => {
                    if (res.code == 200) {
                        toast('申请成功')
                        this.disabled = false;
                        this.showDialog = false;

                        let records = this.records;
                        let applyNotarizationNum = this.applyNotarizationNum;
                        for (let i = 0; i < records.length; i++) {
                            if (records[i].orderSeqNo == applyNotarizationNum) {
                                records[i].evidenceOrder.electronicNotarialStatus = '2';
                                break;
                            }
                        }
                        this.records = records;
                        window.open('/myNotarization', '_blank');

                    } else if (res.code == 214) {
                        toast("请购买会员后使用功能")
                        this.$router.push({path: '/huiyuan.html'})
                    } else if (res.code == 213) {
                        toast("请实名认证后使用功能")
                        if (userInfo.accountType == "person") {
                            this.$router.push('/authentication')
                        } else {
                            this.$router.push('/authentication')
                        }
                    } else {
                        toast(res.message);
                        this.disabled = false;
                    }
                })
            },

            /**************************下载电子存证方法*************************/
            downElectronicNotarialFinish(status, id) {
                if (status == '3') {
                    _downloadEnc(id).then(res => {
                        if (res.code == 200) {
                            window.open(res.result, '_blank')
                        }
                    })
                }
            },
            // ip登录
            async gettokenLogin() {
                let that = this
                let data = {
                    phone: JSON.parse(Cookies.get("userInfo")).account,
                    password: JSON.parse(Cookies.get("userInfo")).password
                };
                let res = await gettokenLogin(data)
                Cookies.set("userInfoIP", JSON.stringify(res.data));
                this.getByPage()
            }
        },
        mounted() {
            this.getByPage()
            // this.gettokenLogin()

        },
    }
</script>
<style scoped lang="less">
    .ipshenqing{
        display: flex;
        align-items: center;
        width: 100%;
        img{
            width: 52px !important;
            height: 52px !important;
            flex: 0 0 52px;
        }
        .info{
            text-align: left;
            margin-left: 15px;
            flex: 1;
            .title{
                font-size: 14px;
                font-weight: 700;
                color: #333;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:1;
                overflow:hidden;
            }
            .money{
                font-size: 14px;
                color: #999999;
                margin-top: 4px;
            }
        }
    }
    .bianji {
        position: relative;
        top: -7px;
        cursor: pointer;
    }

    .editeRemark {
        display: inline-block;
        width: 220px;
        height: 38px;
        background: rgba(255, 255, 255, 1);
        border-radius: 18px;
        border: 1px solid rgba(229, 231, 234, 1);
        margin-bottom: 7px;

        .editeRemark-input {
            height: 36px;
            border: 0px;
            background: transparent;
            outline: none;
            color: #666;
            margin-left: 10px;
            font-size: 14px;
            width: 175px;
            font-weight: 400;
            vertical-align: middle;
        }

        .editeRemark-search-icon {
            width: 20px !important;
            height: 20px !important;
            vertical-align: middle;
            cursor: pointer;
        }
    }

    .showphotow {
        display: inline-block;
        height: 100%;
        position: relative;
        margin-left: 20px;

        .showdiasy {
            position: absolute;
            top: 35px;
            left: 0px;
            background: #fff;
            box-shadow: 0 2px 18px 0 rgba(179, 189, 199, .47);
            border-radius: 4px;
            z-index: 777;
            width: 110px;
            display: none;

            p {
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                font-size: 12px;
                background-color: #fff;
                color: #929292;
            }

            a {
                color: #929292;
            }

            a:hover {
                color: #4e4e4e;
            }

            p:hover {
                background-color: #f7f9fb;
                color: #4e4e4e;
            }
        }

        &:hover {
            .showdiasy {
                display: block;
            }
        }
    }

    .notarization_icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 8px;
    }

    .submit-button {
        width: 230px;
        height: 42px;
        background: rgba(255, 216, 0, 1);
        border-radius: 4px;
        line-height: 42px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
        cursor: pointer;
        border: none;
        outline: none;
    }
    .myTitle{
        font-size: 18px !important;
        font-weight: 700;
        position: relative;
        z-index: 2;
        &::before{
            content: '';
            position: absolute;
            width: 50px;
            background: #2196F3;
            height: 6px;
            border-radius: 3px;
            left: 0;
            bottom: 3px;
            z-index: -1;
        }
    }
    .addBtn{
        background: #fff !important;
        color: #2196F3 !important;
        border: solid 1px #2196F3 !important;
        border-radius: 4px !important;
    }
    .father-box-input{
        display: flex !important;
        align-items: center;
    }
</style>
